import smartlookClient from "smartlook-client";
import { userHasConsentedToStatistics } from "@/utils/cookie-permissions";

function startSmartlook() {
  if (
    typeof window !== "undefined" &&
    process.env.NEXT_PUBLIC_SMARTLOOK_PROJECT_KEY &&
    userHasConsentedToStatistics()
  ) {
    try {
      if (!smartlookClient.initialized()) {
        smartlookClient.init(process.env.NEXT_PUBLIC_SMARTLOOK_PROJECT_KEY);
      }
    } catch {
      //pass
    }
  }
}

// Try to start amplitude as soon as window loads
startSmartlook();

// add event listener to start amplitude when user consent is ready
// this is needed because the user consent might not be ready when window loads
if (typeof window !== "undefined") {
  window.addEventListener("CookiebotOnConsentReady", startSmartlook);
}
